import { getTouchpointName, getAuthentication } from '@account/account-portal/lib'
import { fireUtagLinkEvent } from '@crystal/analytics'

export const trackOverlayOpen = () => {
  const touchPointName = getTouchpointName()
  fireUtagLinkEvent({
    event_category: 'ACCOUNT PORTAL',
    event_name: 'OPEN OVERLAY',
    registration_location: `${touchPointName}`,
  })
}

export const trackOverlayClose = () => {
  const touchPointName = getTouchpointName()
  fireUtagLinkEvent({
    event_category: 'ACCOUNT PORTAL',
    event_name: 'CLOSE OVERLAY',
    registration_location: `${touchPointName}`,
  })
}

export const trackAccountType = (accountType?: string) => {
  const touchPointName = getTouchpointName()
  fireUtagLinkEvent({
    event_category: 'ACCOUNT PORTAL',
    event_name: `AUTH OPTIONS:ACCOUNT TYPE:${accountType || 'NULL'}`,
    registration_location: `${touchPointName}`,
  })
}

export const trackLoginStart = () => {
  const touchPointName = getTouchpointName()
  fireUtagLinkEvent({
    event_category: 'LOGIN',
    event_name: `FORM|START`,
    login_location: `${touchPointName}`,
  })
}

export const trackLoginSuccess = () => {
  const touchPointName = getTouchpointName()
  const { user } = getAuthentication()
  fireUtagLinkEvent({
    event_category: 'LOGIN',
    event_name: `FORM|SUCCESS`,
    customer_email: `${user?.userName}`,
    euci: `${user?.acid ?? ''}`,
    login_location: `${touchPointName}`,
  })
}

export const trackActivationStart = (userAcid: string) => {
  const touchPointName = getTouchpointName()
  fireUtagLinkEvent({
    event_category: 'ACCOUNT CREATION',
    event_name: 'ACTIVATION EMAIL SENT',
    euci: userAcid,
    registration_location: `${touchPointName}`,
  })
}

export const trackLightAccountCreation = (
  userAcid: string,
  email: string,
  paidMediaConsent?: boolean,
  marketingConsent?: boolean,
) => {
  const touchPointName = getTouchpointName()

  const marketingConsentValue = marketingConsent ? 'TRUE' : 'FALSE'
  const paidMediaConsentValue = paidMediaConsent ? 'TRUE' : 'FALSE'
  const form_checkboxes_result = `MARKETING EMAIL CONSENT CHECKED:${marketingConsentValue}, PAID MEDIA CONSENT:${paidMediaConsentValue}`

  fireUtagLinkEvent({
    event_category: 'ACCOUNT CREATION',
    event_name: 'NEW MEMBER LIGHT ACCOUNT|SUCCESS',
    registration_location: `${touchPointName}`,
    customer_email: email,
    euci: userAcid,
    form_checkboxes: [form_checkboxes_result],
  })
}

export const trackFullAccountCreationStart = () => {
  const touchPointName = getTouchpointName()
  fireUtagLinkEvent({
    event_category: 'ACCOUNT CREATION',
    event_name: 'START',
    registration_location: `${touchPointName}`,
  })
}

export const trackFullAccountCreationSuccess = () => {
  const touchPointName = getTouchpointName()
  const { user } = getAuthentication()
  fireUtagLinkEvent({
    event_category: 'ACCOUNT CREATION',
    event_name: 'SUCCESS',
    customer_email: `${user?.userName}`,
    euci: `${user?.acid ?? ''}`,
    registration_location: `${touchPointName}`,
  })
}

export const trackForgetPwStart = () => {
  const touchPointName = getTouchpointName()
  fireUtagLinkEvent({
    event_category: 'LOGIN',
    event_name: 'FORGOT PASSWORD',
    registration_location: `${touchPointName}`,
    euci: '',
  })
}

export const trackForgetPwSuccess = () => {
  const touchPointName = getTouchpointName()
  fireUtagLinkEvent({
    event_category: 'LOGIN',
    event_name: 'FORGOT PASSWORD THANKYOU',
    registration_location: `${touchPointName}`,
    euci: '',
  })
}

const ACCOUNT_CATEGORY = 'ACCOUNT'
const PERSISTENT_SECURITY_CHECKUP = 'PERSISTENT LOGIN SECURITY CHECK'

export const trackFreshAuthenticationOverlayConfirm = () => {
  fireUtagLinkEvent({
    event_category: ACCOUNT_CATEGORY,
    event_name: `${PERSISTENT_SECURITY_CHECKUP}|CONFIRM`,
  })
}

export const trackFreshAuthenticationOverlayLogout = () => {
  fireUtagLinkEvent({
    event_category: ACCOUNT_CATEGORY,
    event_name: `${PERSISTENT_SECURITY_CHECKUP}|LOG OUT`,
  })
}

// tracking requested by Checkout Team - DCAP-20853
export const trackLoginError = () => {
  const touchPointName = getTouchpointName()
  fireUtagLinkEvent({
    event_category: 'FORM ERRORS',
    form_name: 'DWFRM_LOGIN',
    form_error: 'GENERAL',
    form_field_value: [''],
    registration_location: `${touchPointName}`,
  })
}

export const trackFakeDoorOTP = () => {
  fireUtagLinkEvent({
    event_category: 'LOGIN',
    event_name: `EMAIL OTP FAKE DOOR TEST`,
  })
}

export const trackSwitchToEmailInput = () => {
  const touchPointName = getTouchpointName()
  fireUtagLinkEvent({
    event_category: 'LOGIN',
    event_name: 'LOGIN|EMAIL|START',
    login_location: touchPointName,
  })
}
